import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { SortArrow } from 'lib/styles/icons';
import useContractTable from 'hooks/contract/useContractTable';
import Loading from 'components/common/Loading';
import ErrorNoti from 'components/common/ErrorNoti';
import { SORT } from 'lib/constant/index';
import Pagination from 'components/common/Pagination';

const Row = ({ contract, idx }) => {
  const navigate = useNavigate();
  const { id, createdAt, company, name, type } = contract;
  const date = createdAt.split(' ')[0];

  return (
    <RowBlock onClick={() => navigate(`${id}`)}>
      <div className="number">{idx + 1}</div>
      <div className="createdAt">{date}</div>
      <div className="company ellipsis" title={company}>
        {company}
      </div>
      <div className="name ellipsis" title={name}>
        {name}
      </div>
      <div className="type">{type}</div>
    </RowBlock>
  );
};

const RowBlock = styled.div`
  display: flex;
  cursor: pointer;
  .number {
    width: 10%;
  }
  .createdAt {
    width: 30%;
  }
  .company {
    width: 20%;
  }
  .name {
    width: 20%;
  }
  .type {
    width: 20%;
  }
  div {
    text-align: center;
  }
  padding: 10px 0;
  & + & {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
`;

const ContractTable = () => {
  const {
    currentPage,
    isLoading,
    error,
    totalPage,
    contractList,
    setCurrentPage,
    onSort,
  } = useContractTable();

  if (isLoading) return <Loading marginTop />;
  if (error?.response.status === 500) return <ErrorNoti marginTop />;

  return (
    <ContractTableBlock>
      <Header>
        <div className="number">
          <span>번호</span>
        </div>
        <div className="createdAt">
          <span>계약 등록일</span>
          <SortArrow onClick={() => onSort(SORT.DATE)} />
        </div>
        <div className="company">
          <span>소속</span>
        </div>
        <div className="name">담당자</div>
        <div className="type">
          <span>구분</span>
          <SortArrow onClick={() => onSort(SORT.TYPE)} />
        </div>
      </Header>
      {contractList?.length === 0 ? (
        <div className="search-nothing">검색결과가 없습니다</div>
      ) : (
        contractList?.map((contract, idx) => (
          <Row
            key={`contractId-${idx}`}
            contract={contract}
            idx={idx + (currentPage - 1) * 10}
          />
        ))
      )}
      <Pagination
        totalPage={totalPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </ContractTableBlock>
  );
};

export default ContractTable;

const ContractTableBlock = styled.div`
  margin-top: 30px;
  padding: 0 30px;
  border: solid 1px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.08);

  .search-nothing {
    padding: 4rem 0;
    display: flex;
    justify-content: center;
    font-weight: 500;
    letter-spacing: 2px;
  }
`;

const Header = styled.div`
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  font-weight: bold;
  padding: 15px 0;

  .number {
    width: 10%;
  }

  .createdAt {
    width: 30%;
  }

  .company {
    width: 20%;
  }

  .name {
    width: 20%;
  }

  .type {
    width: 20%;
  }

  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  span {
    margin-right: 5px;
  }
`;
